<template>
  <div class="left-sidebar col-md-3">
    <!-- <div class="left-sidebar-news" :class='isNews?"d-none":""'>
      <div class="news-title">
        <span>新闻资讯</span>
      </div>
      <ul class="news-box">
        <li class="news-items" v-for="(newsData, index) in News.slice(0,5)" :key="index">
          <i class="news-icon iconfont icon-jiantouarrowheads3"></i>
          <router-link tag="a" :to="`/newscontent/${newsData._id}`" class="news-link text-ellipsis">{{newsData.title}}</router-link>
        </li>
      </ul>
    </div> -->
    <!-- <div class="left-sidebar-news">
      <div class="news-title">
        <span>热销产品</span>
      </div>
      <ul class="news-box" v-if="productsData[0]">
        <li class="news-items" v-for="(data, index) in productsData[0].productsList.slice(0,5)" :key="index">
          <i class="news-icon iconfont icon-dian"></i>
          <router-link
            tag="a"
            :to="`/productscontent/${data._id}`"
            class="news-link text-ellipsis"
          >{{data.name}}</router-link>
        </li>
      </ul>
    </div> -->
    <div class="left-sidebar-news">
      <div class="news-title">
        <span v-if="currentLanguage == 'CN'">联系我们</span>
        <span v-else-if="currentLanguage == 'EN'">Contact</span>
        <span v-else-if="currentLanguage == 'JP'">お問い合わせ</span>
      </div>
      <div class="about-info" v-cloak>
        <p>{{basicinfoData.manager}}</p>
        <p>{{basicinfoData.phone}}</p>
        <p>{{basicinfoData.email}}</p>
        <p>{{basicinfoData.address}}</p>
      </div>
    </div>
  </div>
</template>
<script>
    import baseDataCN from '../data/CN/basicinfoData_CN.json'
    import baseDataEN from '../data/EN/basicinfoData_EN.json'
    import baseDataJP from '../data/JP/basicinfoData_JP.json'
export default {
  props: {
    isNews: { type: Boolean }
  },
  data() {
    return {
      News: [],
      productsData: [],
      currentLanguage: '', // 当前语言
      basicinfoData: []
    }
  },
  mounted() {
      const _this = this
      window.addEventListener('setItemEvent', function(e) {
          // e.key : 是值发生变化的key
          // 例如 e.key==="token";
          // e.newValue : 是可以对应的新值
          if (e.key === 'language') {
              var d = e.newValue
              _this.currentLanguage = e.newValue
              if (d === 'CN') {
                  _this.basicinfoData = baseDataCN
              } else if (d === 'EN') {
                  _this.basicinfoData = baseDataEN
              } else if (d === 'JP') {
                  _this.basicinfoData = baseDataJP
              }
          }
      })
  },
  methods: {
    // 查询所有的基本信息
    findBasicinfo: async function() {
      // const res = await this.$http.get('basicinfo')
      var lg = localStorage.getItem('language')
      this.currentLanguage = lg
      if (lg === 'CN') {
          this.basicinfoData = baseDataCN
      } else if (lg === 'EN') {
          this.basicinfoData = baseDataEN
      } else if (lg === 'JP') {
          this.basicinfoData = baseDataJP
      }
    },
    // 获取新闻列表
    findNews: async function() {
      const res = await this.$http.get('/news')
      this.News = res.data
    },
    // 查询所有的产品
    findProductsData: async function() {
      const res = await this.$http.get('productslist')
      this.productsData = res.data
    }
  },
  created() {
    // this.findProductsData()
    this.findBasicinfo()
    // this.findNews()
  }
}
</script>

<style scoped>
.left-sidebar-news {
  margin-bottom: 26px;
}
.news-title {
  border-bottom: 1px solid #cccccc;
  margin-bottom: 6px;
}
.news-title span {
  display: inline-block;
  font-size: 22px;
  padding: 4px 0;
  position: relative;
  bottom: -1px;
  border-bottom: 1px solid #048bd4;
  color: #048bd4;
}

.news-items {
  padding: 6px 0;
  width: 100%;
  display: flex;
  border-bottom: 1px solid #f2f2f2;
}

.news-link {
  width: 100%;
  margin-top: 1px;
  color: #999;
}
.news-link:hover {
  color: #048bd4;
}

.news-icon {
  display: inline-block;
  transform: rotate(180deg);
  margin-left: -1px;
  margin-right: 8px;
  flex: 1;
  color: #048bd4;
}
.about-info {
  margin-top: 10px;
  font-size: 14px;
  color: #999;
  line-height: 28px;
}
</style>